import {
    GROUP_BY_YEAR_KEYS,
    SECTION_KEYS,
    SECTION_YEAR_GETTERS,
    SINGLE_SELECT_KEYS,
} from './accountImportConstants';

export const createDefaultSelection = () => SECTION_KEYS.reduce((acc, key) => {
    acc[key] = { mode: SINGLE_SELECT_KEYS.has(key) ? 'include' : 'all', values: new Set() };
    return acc;
}, {});

export const createEmptySelectionPayload = () => ({
    profileIds: [],
    customerIds: [],
    supplierIds: [],
    articleNumbers: [],
    shippingCostIds: [],
    invoiceIds: [],
    bookingIds: [],
});

export const normalizeYearKey = (value) => {
    if (value == null) {
        return 'Unbekannt';
    }
    const text = String(value).trim();
    return text ? text : 'Unbekannt';
};

export const extractYear = (value) => {
    if (value == null || value === '') {
        return null;
    }
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return String(value.getFullYear());
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        if (value >= 1000 && value <= 9999) {
            return String(Math.trunc(value));
        }
        const numericText = String(Math.trunc(value));
        const compactNumericMatch = numericText.match(/^(\d{4})(\d{2})(\d{2})$/);
        if (compactNumericMatch) {
            return compactNumericMatch[1];
        }
        const parsed = new Date(value);
        if (!Number.isNaN(parsed.getTime())) {
            return String(parsed.getFullYear());
        }
    }
    const text = String(value).trim();
    if (!text) {
        return null;
    }
    const yearOnlyMatch = text.match(/^(\d{4})$/);
    if (yearOnlyMatch) {
        return yearOnlyMatch[1];
    }
    const compactMatch = text.match(/^(\d{4})(\d{2})(\d{2})$/);
    if (compactMatch) {
        return compactMatch[1];
    }
    const yearFirstMatch = text.match(/^(\d{4})[./-]/);
    if (yearFirstMatch) {
        return yearFirstMatch[1];
    }
    const dayFirstMatch = text.match(/(\d{1,2})[./-](\d{1,2})[./-](\d{4})/);
    if (dayFirstMatch) {
        return dayFirstMatch[3];
    }
    const shortYearMatch = text.match(/(\d{1,2})[./-](\d{1,2})[./-](\d{2})\b/);
    if (shortYearMatch) {
        const yearValue = Number.parseInt(shortYearMatch[3], 10);
        if (!Number.isNaN(yearValue)) {
            return String(yearValue >= 70 ? 1900 + yearValue : 2000 + yearValue);
        }
    }
    const yearInTextMatch = text.match(/\b(19|20)\d{2}\b/);
    if (yearInTextMatch) {
        return yearInTextMatch[0];
    }
    const parsed = new Date(text);
    if (!Number.isNaN(parsed.getTime())) {
        return String(parsed.getFullYear());
    }
    return null;
};

export const resolveItemYearKey = (sectionKey, item) => {
    if (!GROUP_BY_YEAR_KEYS.has(sectionKey)) {
        return null;
    }
    const getYearValue = SECTION_YEAR_GETTERS[sectionKey];
    const rawValue = getYearValue ? getYearValue(item) : null;
    const yearValue = extractYear(rawValue);
    return normalizeYearKey(yearValue);
};

export const buildYearId = (key, yearKey) => `${key}:${yearKey}`;

export const formatCurrency = (value) => {
    if (value == null || value === '') {
        return '';
    }
    try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(value));
    } catch (error) {
        return value;
    }
};

export const sortYearKeys = (keys) => {
    return [...keys].sort((a, b) => {
        const aNum = Number.parseInt(a, 10);
        const bNum = Number.parseInt(b, 10);
        const aValid = !Number.isNaN(aNum);
        const bValid = !Number.isNaN(bNum);
        if (aValid && bValid) {
            return bNum - aNum;
        }
        if (aValid) {
            return -1;
        }
        if (bValid) {
            return 1;
        }
        return String(a).localeCompare(String(b));
    });
};
